export default __webpack_public_path__ + "static/media/logoLightBackground.59219783.svg";